<template>
  <div>
    <div class="nightreturn-container" v-if="isPhone">
      <el-date-picker
        v-model="search.date"
        size="small"
        type="daterange"
        :clearable="false"
        :range-separator="$t('app.to')"
        :start-placeholder="$t('app.startSearchDate')"
        :end-placeholder="$t('app.endSearchDate')"
        class="search-condition"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="reset">{{
        $t("app.reset")
      }}</el-button>
      <el-button
        type="success"
        icon="el-icon-search"
        size="small"
        @click="getList"
        >{{ $t("app.search") }}</el-button
      >
      <el-table
        :data="tableData"
        height="700"
        style="width: 100%; color: black"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" class="demo-table-expand">
              <el-form-item label="中文名">
                <span>{{ scope.row.nameChina }}</span>
              </el-form-item>
              <el-form-item label="原因">
                <span>{{ scope.row.reason }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <template v-for="col in column">
          <el-table-column
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            v-if="
              !isPhone
                ? phoneTable.findIndex((item) => item === col.model) != -1
                : pcTable.findIndex((item) => item === col.model) != -1
            "
          >
            <template slot-scope="scope">
              <template>
                {{ scope.row[col.model] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-pagination
        style="text-align: center; margin-top: 20px"
        background
        :total="total"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="getList"
        :page-sizes="[10, 50, 200, 1000]"
        :page-size="size"
        layout="total, sizes, prev, pager, next"
      >
      </el-pagination>
    </div>
    <div v-else>
      <van-list
        class="vanListBox"
        v-model="mLoading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="list-item" v-for="(item, index) in tableData" :key="index">
          <div class="title">
            <div class="name">
              <div>中文：{{ item.ChineseName }}</div>
              <div>English：{{ item.EnglishName }}</div>
            </div>
            <div class="time">时间：{{ item.ApplyDate }}</div>
          </div>
          <div class="content">
            <div>房間編號： {{ item.CurrentRoom }}</div>
            <div>外宿目的地： {{ item.Destination }}</div>
            <div>申報事項： {{ item.ApplyItem }}</div>
            <div>異常情況： {{ item.Result }}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getReturnList } from "@/api/oldStudent";
import { delEmpty } from "@/utils/utils";
import dayjs from "dayjs";
export default {
  components: {},
  computed: {
    isPhone() {
      return this.$store.state.Config.isPhone;
    },
  },
  data() {
    return {
      dateInput: "",
      showCalendar: false,
      auto: false,
      time: "",
      loading: false,
      phoneTable: ["destination", "date", "case"],
      pcTable: ["nameEnglish", "room", "items", "destination", "date", "case"],
      column: [
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        {
          model: "contactInformation",
          label: this.$t("app.contactInformation"),
        },
        {
          model: "room",
          label: this.$t("app.roomCode"),
        },
        {
          model: "items",
          label: this.$t("app.declarationItems"),
        },
        {
          model: "destination",
          label: this.$t("app.sleepOutDestination"),
        },
        {
          model: "date",
          label: this.$t("app.DateofReturnLateOrSleepOut"),
        },
        {
          model: "case",
          label: this.$t("app.ExceptionStatus"),
        },
      ],
      search: {
        date: [],
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      finished: false,
      mLoading: false,
      list: [],
    };
  },
  watch: {
    "search.date": {
      handler(newVal) {
        if (newVal[0]) {
          this.dateInput =
            dayjs(this.search.date[0]).format("YYYY-MM-DD") +
            "/" +
            dayjs(this.search.date[1]).format("YYYY-MM-DD");
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.isPhone) {
      this.getList();
    }
  },
  methods: {
    // 移动端数据
    async onLoad() {
      const res = await getReturnList(
        delEmpty({
          StartApplyDateTime: this.search.date[0],
          EndApplyDateTime: this.search.date[1],
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      );
      if (this.currentPage == 1) {
        this.tableData = [];
      }
      this.tableData = this.tableData.concat(res.data.Items);
      this.mLoading = false;
      if (this.tableData.length === res.data.Total) {
        this.finished = true;
      } else {
        this.currentPage += 1;
      }

      // 异步更新数据
      // setTimeout(() => {
      //   for (let i = 0; i < 10; i++) {
      //     this.list.push(this.list.length + 1);
      //   }
      //   // 加载状态结束
      //   this.mLoading = false;
      //   // 数据全部加载完成
      //   if (this.list.length >= 40) {
      //     this.finished = true;
      //   }
      // }, 1000);
    },
    // 日期选择器
    async onConfirm(date) {
      this.$set(this.search.date, 0, date[0]);
      this.$set(this.search.date, 1, date[1]);
      await this.getList();
      this.showCalendar = false;
    },
    closeSearchFun() {
      this.dateInput = "";
      this.$set(this.search.date, 0, "");
      this.$set(this.search.date, 1, "");
      this.getList();
    },
    //
    showCalendarFn() {
      this.showCalendar = true;
    },
    async getList() {
      const res = await getReturnList(
        delEmpty({
          StartApplyDateTime: this.search.date[0],
          EndApplyDateTime: this.search.date[1],
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      );

      this.total = res.data.Total;
      if (res.data.Items && res.data.Items.length > 0) {
        this.tableData = res.data.Items.map((item) => {
          return {
            room: item.CurrentRoom,
            nameEnglish: item.EnglishName,
            studentNumber: item.StudentCode,
            reason: item.ApplyReason,
            case: item.Result,
            contactInformation: item.ContactMobile,
            date: item.ApplyDate,
            items: item.ApplyItem,
            nameChina: item.ChineseName,
            destination: item.Destination,
          };
        });
      } else {
        this.tableData = [];
      }
    },
    reset() {
      this.search.date = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.nightreturn-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
.search-condition {
  margin-right: 10px;
}
.search-div-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  width: 100%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  i {
    font-size: 18px;
  }
}
.vanListBox {
  height: calc(100vh - 160px);
}
.list-item {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0 ;
  overflow: hidden;
  // box-shadow: 0 5px 10px rgba($color: #000000, $alpha: 0.3);
  margin-bottom: 20px;
  .title {
    width: 100%;
    display: flex;
    background-color: #119f7b;
    color: #fff;
    padding: 10px;
  }
  .name {
    flex: 1;
  }
  .time {
    width: 120px;
    flex-shrink: 0;
  }
  .content {
    padding: 10px;
    border: 1px solid #eee;
    div{
      line-height: 1.6;
      padding: 5px 0;
      border-bottom:1px solid #f2f2f2 ;
      &:last-child{
        border: none;
      }
    }
  }
}
</style>
